import { pushToast, dismissToast, TOAST_DEFAULT_DURATION_MS } from "../stores/toastStore";

function show(type, message, options = {}) {
    const durationMs =
        options?.durationMs != null ? options.durationMs : TOAST_DEFAULT_DURATION_MS;
    return pushToast({ type, message, durationMs });
}

export const toast = {
    success(message, options) {
        return show("success", message, options);
    },
    error(message, options) {
        return show("error", message, options);
    },
    warning(message, options) {
        return show("warning", message, options);
    },
    info(message, options) {
        return show("info", message, options);
    },
    dismiss(id) {
        dismissToast(id);
    },
};

export default toast;
